<geaui-page-content-layout class="documents-page">
  <ng-container page-header>
    <geaui-page-header
      pageTitle="Documents"
      [hasBackArrow]="false"
      [withSidebar]="true"
    >
    </geaui-page-header>
  </ng-container>

  <ng-container page-content>
    <div
      class="documents-content geaui-grid geaui-sidebar-grid geaui-scrollable-table"
    >
      <div
        class="documents-filters geaui-col-desktop-xl-start-7 geaui-col-desktop-xl-12 geaui-col-desktop-lg-12 geaui-col-desktop-md-12"
      >
        <geaui-search-bar-v2
          [id]="'search-bar'"
          [group]="searchForm"
          formName="search"
          [placeholder]="searchPlaceholder"
          [showBottomBorderOnly]="true"
          [hasSuggestions]="false"
          [hasProminentButton]="false"
          (valueChanged)="searchValueChanged($event)"
          (clearEvent)="searchValueChanged('')"
        >
        </geaui-search-bar-v2>
        <hrt-filter-chips
          [columnDefinitions]="columnDefinitions"
          [activeChipFilters]="activeChipFilters"
          [globalSearch]="'Documents Search'"
          [tableId]="tableId"
          (chipRemoved)="onChipRemoved($event)"
        ></hrt-filter-chips>
      </div>
      <geaui-table-v3
        [tableId]="tableId"
        [columnDefinitions]="columnDefinitions"
        [data]="docResponse"
        [totalRecords]="count"
        [loading]="isTableLoading"
        [isLandingPage]="true"
        [rowsClickable]="true"
        [isLandingPage]="true"
        [sortable]="true"
        (rowClicked)="onRowClicked($event)"
        [nonClickableColumns]="['Actions']"
        [noEntriesInfoText]="'No entries available, try different filters.'"
        [noEntriesTitle]="'No Documents Found'"
        class="geaui-col-desktop-xl-start-7 geaui-col-desktop-xl-12 geaui-col-desktop-lg-12 geaui-col-desktop-md-12 geaui-col-tablet-lg-12 geaui-col-tablet-sm-12 geaui-col-phone-lg-8 geaui-col-phone-sm-4"
      ></geaui-table-v3>
    </div>
  </ng-container>
</geaui-page-content-layout>
